import React, { Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";

import {
	Container,
	Row,
	Col,
	CardBody,
	Card,
	CardTitle,
	CardSubtitle,
	Button,
	Fieldset,
	Legend,
	Tooltip,
	Modal
} from "reactstrap";


import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
	AvForm,
	AvGroup,
	AvInput,
	AvField,
	AvCheckboxGroup,
	AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"

import { Link, useHistory, Redirect } from "react-router-dom";
import apiResponse from "../../../../services/apiResponse";
import CreateBloc from "./Blocs/CreateBloc";
import { accessRole } from "../../../../helpers/access_role";
import CustomSelect from "../../GlobalComponents/CustomSelect";
import moment from "moment";

var reformatEmployee = function (employee) {
	return employee.map(function (region) {
		var newObj = {};
		newObj["label"] = region.employee_nip + " - " + region.employee_full_name;
		newObj["value"] = region.employee_uuid;
		newObj["model"] = region;
		return newObj;
	});
};

var reformatRank = function (ranks) {
	return ranks.map(function (rank) {
		var newObj = {};
		newObj["label"] = rank.rank_name + ' - ' + rank.rank_group_room;
		newObj["value"] = rank.rank_uuid;
		newObj["model"] = rank;
		return newObj;
	});
};
var reformatOptionPosition = function (option) {
	return option.map(function (opsi) {
		var newObj = {};
		newObj["label"] = opsi.position_name;
		newObj["value"] = opsi.position_uuid;

		return newObj;
	});
};
var reformatType = function (regions) {
	return regions.map(function (region) {
		var newObj = {};
		newObj["label"] = region.retired_type_name;
		newObj["value"] = region.retired_type_uuid;
		return newObj;
	});
};


class IndexView extends Component {
	createBloc = new CreateBloc();
	queryParams = new URLSearchParams(window.location.search)
	userdata = JSON.parse(localStorage.getItem('userdata'));

	constructor(props) {
		super(props);
		this.state = {
			peg_uuid: "",
			isLoadingOptEmployee: true,
			is_koreksi_kehadiran: false,
			is_grade: false,
			is_dinas: false,
			is_cuti: false,
			listExclude: [],
			dataForm: {
				financial_revision_period_uuid: props.uuid,
			},
			employeeItems: [],
			rankItems: [],
			employeeSelected: props.pegawai_uuid,
			pangkatSelected: "",
			typeItems: [],
			typeSelected: "",
			rankGroupRoom: "",
			loadingTable: false,
			rows: [],
			cancelDate: null,
			result_type: null,
			confirmInfo: "",
			modal: false,
			modalSize: 'sm',
			positionItems: [],
			PositionSelected: null,
			RankSelected: null,
			SendPositionSelected: null,
			SendRankSelected: null,
			GradeSelected: null,
			GenerateType: null,
			rev_tunkin: 0,
			rev_honorarium: 0,
			rev_uangmakan: 0,
			rev_edit: false
		};
		this.setPosition = this.setPosition.bind(this);
		this.setPositionGrade = this.setPositionGrade.bind(this);
	}
	setPosition = (jenis) => {
		console.log(jenis);
		// this.setState({ 
		// 	SendPositionSelected: e.value,
		// 	GradeSelected: e.target.value 
		// });
		// this.SendSetPosition();
	}
	setPositionGrade = (e) => {
		this.setState({
			GradeSelected: e.target.value
		});
		this.SendSetPosition();
	}

	cancelDate = async () => {
		const query = {
			uuid: this.props.uuid,
			date: this.state.cancelDate,
			result_type: this.state.result_type,
			pegawai_uuid: this.queryParams.get('pegawai_uuid'),
			pegawai_nip: this.state.data_summary.presensi_summary_employee_nip,
			period_financial_revision_uuid: this.props.uuid,
			revision_uuid : this.queryParams.get('revision_uuid')
		}
		
		await this.createBloc.fetchDeletePresensi(query)
	}
	revFlag = async () => {
		const query = {
			uuid: this.props.uuid,
			date: this.state.cancelDate,
			result_type: this.state.result_type,
			pegawai_uuid: this.queryParams.get('pegawai_uuid'),
			pegawai_nip: this.state.data_summary.presensi_summary_employee_nip,
			period_financial_revision_uuid: this.props.uuid,
			revision_uuid : this.queryParams.get('revision_uuid'),
			rev_tunkin: this.state.rev_tunkin,
			rev_honorarium: this.state.rev_honorarium,
			rev_uangmakan: this.state.rev_uangmakan,
		}
		
		await this.createBloc.fetchFlagRev(query)
	}
	generateUlang = async () => {
		this.setState({
			//loadingTable: false,
			loading: true,
		})
		const query = {
			uuid: this.props.uuid,
			result_type: this.state.result_type,
			year: this.state.data_periode.period_financial_revision_year,
			month: this.state.data_periode.period_financial_revision_month,
			pegawai_uuid: this.queryParams.get('pegawai_uuid'),
			pegawai_nip: this.state.data_summary.presensi_summary_employee_nip,
			type: this.state.GenerateType,
			financial_revision_uuid: this.queryParams.get('revision_uuid'),
		}

		await this.createBloc.fetchGeneratePresensi(query)
	}

	SendSetPosition = async (e) => {
		const query = {
			uuid: this.props.uuid,
			result_type: this.state.result_type,
			year: this.state.data_periode.period_financial_revision_year,
			month: this.state.data_periode.period_financial_revision_month,
			pegawai_uuid: this.queryParams.get('pegawai_uuid'),
			pegawai_nip: this.state.data_summary.presensi_summary_employee_nip,
			position_uuid: this.state.SendPositionSelected,
			grade: this.state.GradeSelected
		}
		await this.createBloc.fetchUpdateJabatan(query)
	}

	getIconPresensi = (inp, val) => {
		if (inp != null) {
			if (val == 'Finger Print') {
				return (
					<>
						<br /> <i className="bx bx-fingerprint"></i>
					</>
				)
			}

			if (val == 'Mobile') {
				return (
					<>
						<br /> <i className="bx bx-mobile-alt"></i>
					</>
				)
			}
		}
		return '';
	}
	dateParse = (input) => {
		let res = "-";
		if (input != "" && input != null) {
			res = moment(input).format('DD/MM/YYYY')
		}
		return res;
	}
	setModalSize = (size) => {
		this.setState({
			modalSize: size
		})
	}

	closeModal = (reload = false) => {
		this.setState({
			showUpload: false
		})
		setTimeout(() => {
			this.setState({
				modalSize: 'sm'
			})
		}, 500);
		if (reload) {
			this.setState({
				showTable: false
			}, function () {
				setTimeout(() => {
					this.setState({
						showTable: true
					})
				}, 100)
			})
		}
	}

	updateGrade = () => {
		this.setState({ modal: !this.state.modal })
	}

	addList = () => {
		let emp = this.state.selectedEmployee;
		let obj = {
			uuid: emp.employee_uuid,
			nip: emp.employee_nip,
			nama: emp.employee_full_name
		}
		let temp = this.state.listExclude.filter((val) => val.nip != emp.employee_nip)
		temp.push(obj);
		//console.log(temp)
		this.setState({
			listExclude: temp
		})
	}

	deleteList = (data) => {
		this.setState({
			listExclude: [
				...this.state.listExclude.filter((val) => val.nip != data.nip)
			]
		})
	}

	submitData = async () => {
		const formData = generateFormData(this.state.dataForm); // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
		// await this.createBloc.fetchCreate(formData);
		await this.createBloc.fetchFlagRev(formData);
	};

	handlerOnSubmit = (e, values) => {
		e.preventDefault();
		var list_pegawai_nip = [];
		var list_pegawai_uuid = [];
		var idx = 0;
		(this.state.listExclude).forEach((el) => {
			list_pegawai_nip[idx] = el.nip;
			list_pegawai_uuid[idx] = el.uuid;
			console.log(el)
			idx++;
		})
		var peg_uuid = (this.userdata != null ? this.userdata.employee_uuid : "");
		this.setState({
			dataForm: {
				financial_revision_period_uuid: this.queryParams.get('uuid'),
				financial_revision_employee_nip: list_pegawai_nip,
				financial_revision_employee_uuid: list_pegawai_uuid,
				peg_uuid: peg_uuid,
				rev_tunkin: this.state.rev_tunkin,
				rev_honorarium: this.state.rev_honorarium,
				rev_uangmakan: this.state.rev_uangmakan,
				...values,
			},
			confirm: true,
		});
		//console.log(this.state.dataForm);
	};


	confirmResponse = (response) => {
		let forState = {};
		switch (response) {
			case "cancel":
				forState = {
					confirm: false,
				};
				break;
			case "confirm":
				forState = {
					loading: true,
					confirm: false,
				};
				if(this.state.rev_edit==true){
					this.revFlag();
				}else{
					this.cancelDate();
				}
				break;
			case "success":
				if(this.state.rev_edit==true){
					forState = {
						success: false,
						redirect: true,
					};
				}else{
					forState = {
						success: false,
						redirect: false,
					};
				}
				break;
			case "failed":
				forState = {
					failed: false,
				};
				break;
			default:
		}
		this.setState(forState);
	};

	componentDidMount() {
		this.createBloc.listPresensiChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.INITIAL:
					this.setState({
						loadingTable: false,
						loading: false,
						rows: []
					})
					break
				case apiResponse.LOADING:
					this.setState({
						loadingTable: true,
						loading: true
					})
					break
				case apiResponse.COMPLETED:
					const response = result.data.response
					console.log(response);
					this.setState({
						rows: response.result,
						loading: false
					})
					break
				case apiResponse.ERROR:

					break
				default:
					break
			}
		})

		this.createBloc.deletePresensi.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					this.setState({
						loading: false,
						success: true,
						redirect: false
					});
					this.createBloc.fetchDetailPegawai({ revision_period_uuid: this.queryParams.get('uuid'), pegawai_uuid: this.queryParams.get('pegawai_uuid') });
					this.createBloc.fetchDetail({ uuid: this.queryParams.get('uuid') });
					this.createBloc.fetchListPresensi({ uuid: this.queryParams.get('pegawai_uuid'), revision_period_uuid: this.queryParams.get('uuid') });

					break;
				case apiResponse.ERROR:
					this.setState({
						loading: false,
						failed: true,
						redirect: false
					});
					break;
				default:
					break;
			}
		})
		this.createBloc.listJabatanChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					if (result.data.status) {
						let response = result.data.response

						this.setState({
							positionItems: reformatOptionPosition(response.result.jabatan),
							rankItems: reformatRank(response.result.rank)
						})
					}
					break
				case apiResponse.ERROR:

					break
				default:
					break
			}
		})
		this.createBloc.generatePresensi.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					this.setState({
						loading: false,
						success: true,
						redirect: false
					});
					this.createBloc.fetchDetailPegawai({ revision_period_uuid: this.queryParams.get('uuid'), pegawai_uuid: this.queryParams.get('pegawai_uuid') });
					this.createBloc.fetchDetail({ uuid: this.queryParams.get('uuid') });
					this.createBloc.fetchListPresensi({ uuid: this.queryParams.get('pegawai_uuid'), revision_period_uuid: this.queryParams.get('uuid') });

					break;
				case apiResponse.ERROR:
					this.setState({
						loading: false,
						failed: true,
						redirect: false
					});
					break;
				default:
					break;
			}
		})

		this.createBloc.createChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					this.setState({
						loading: false,
						success: true,
					});
					break;
				case apiResponse.ERROR:
					this.setState({
						loading: false,
						failed: true,
					});
					break;
				default:
					break;
			}
		});
		this.createBloc.flagRevChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					this.setState({
						loading: false,
						success: true,
					});
					break;
				case apiResponse.ERROR:
					this.setState({
						loading: false,
						failed: true,
					});
					break;
				default:
					break;
			}
		});

		this.createBloc.employeeChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					if (result.data.status) {
						let response = result.data.response;
						this.setState({
							employeeItems: reformatEmployee(response.result),
						});
					}
					break;
				case apiResponse.ERROR:
					break;
				default:
					break;
			}
		});



		this.createBloc.detailChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					if (result.data.status) {
						let response = result.data.response;
						this.setState({
							detailPeriode: response,
						});
					}
					break;
				case apiResponse.ERROR:
					break;
				default:
					break;
			}
		});

		this.createBloc.detailPegawaiChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					if (result.data.status) {
						let response = result.data.response;
						this.setState({
							data_summary: response.data_summary,
							data_periode: response.data_periode,
							saldo: response.saldo,
							PositionSelected: response.data_summary.presensi_summary_employee_current_position_uuid,
							SendPositionSelected: response.data_summary.presensi_summary_employee_current_position_uuid,
							RankSelected: response.data_summary.presensi_summary_employee_current_rank_uuid,
							GradeSelected: response.data_summary.presensi_summary_employee_current_grade,
							rev_tunkin: ((response.data_summary.presensi_summary_revisi_is_tunkin_revisi==1)?1:0),
							rev_honorarium: ((response.data_summary.presensi_summary_revisi_is_honorarium_revisi==1)?1:0),
							rev_uangmakan: ((response.data_summary.presensi_summary_revisi_is_uang_makan_revisi==1)?1:0),
						});
					}
					break;
				case apiResponse.ERROR:
					break;
				default:
					break;
			}
		});

		this.createBloc.fetchDetailPegawai({ revision_period_uuid: this.queryParams.get('uuid'), pegawai_uuid: this.queryParams.get('pegawai_uuid'), pegawai_nip: this.queryParams.get('pegawai_nip') });

		//this.createBloc.fetchEmployee();
		this.createBloc.fetchDetail({ uuid: this.queryParams.get('uuid') });
		this.createBloc.fetchListPresensi({ uuid: this.queryParams.get('pegawai_uuid'), revision_period_uuid: this.queryParams.get('uuid') });
		this.createBloc.fetchListJabatan();


	}

	componentWillUnmount() {
		this.createBloc.createChannel.unsubscribe()
		this.createBloc.employeeChannel.unsubscribe()
		this.createBloc.typeChannel.unsubscribe()
		this.createBloc.detailChannel.unsubscribe()
		this.createBloc.rankChannel.unsubscribe()
		this.createBloc.detailPegawaiChannel.unsubscribe()
		this.createBloc.listPresensiChannel.unsubscribe()
		this.createBloc.listJabatanChannel.unsubscribe()

	}

	render() {
		return (
			<Fragment>
				<Container fluid>
					<Row>
						<Col className="col-12">
							<Card className="">
								<CardBody>
									<div className="float-end">
									</div>
									<CardTitle>Revisi Pegawai</CardTitle>

									<CardSubtitle className="mb-3">
										Setiap isian yang bertanda (
										<span className="text-danger ">*</span>) adalah wajib diisi.
									</CardSubtitle>

									<hr />
									<AvForm
										className="needs-validation"
										onValidSubmit={(e, values) =>
											this.handlerOnSubmit(e, values)
										}
									>
										<Row className="mb-1">
											<label
												className="col-md-2 col-form-label pt-0"
											>
												Periode
											</label>
											<Col md="10">
												{this.state.data_periode ? (
													<>
														{this.state.data_periode.period_financial_revision_periode !== "" && this.state.data_periode.period_financial_revision_periode !== null
															? this.state.data_periode.period_financial_revision_periode
															: "-"}
													</>
												) : (
													<Shimmer>
														<div style={{ width: "100%", height: '15px' }}></div>
													</Shimmer>
												)}

											</Col>
										</Row>
										<Row className="mb-1">
											<label
												className="col-md-2 col-form-label pt-0"
											>
												Nip
											</label>
											<Col md="10">
												{this.state.data_summary ? (
													<>
														{this.state.data_summary.presensi_summary_employee_nip !== "" && this.state.data_summary.presensi_summary_employee_nip !== null
															? this.state.data_summary.presensi_summary_employee_nip
															: "-"}
													</>
												) : (
													<Shimmer>
														<div style={{ width: "100%", height: '15px' }}></div>
													</Shimmer>
												)}

											</Col>
										</Row>
										<Row className="mb-1">
											<label
												className="col-md-2 col-form-label pt-0"
											>
												Nama
											</label>
											<Col md="10">
												{this.state.data_summary ? (
													<>
														{this.state.data_summary.presensi_summary_employee_full_name !== "" && this.state.data_summary.presensi_summary_employee_full_name !== null
															? this.state.data_summary.presensi_summary_employee_full_name
															: "-"}
													</>
												) : (
													<Shimmer>
														<div style={{ width: "100%", height: '15px' }}></div>
													</Shimmer>
												)}

											</Col>
										</Row>
										<Row className="mb-1">
											<label
												className="col-md-2 col-form-label pt-0"
											>
												Unit Kerja
											</label>
											<Col md="10">
												{this.state.data_summary ? (
													<>
														{this.state.data_summary.presensi_summary_employee_current_work_unit_name !== "" && this.state.data_summary.presensi_summary_employee_current_work_unit_name !== null
															? this.state.data_summary.presensi_summary_employee_current_work_unit_name
															: "-"}
													</>
												) : (
													<Shimmer>
														<div style={{ width: "100%", height: '15px' }}></div>
													</Shimmer>
												)}

											</Col>
										</Row>
										<Row className="mb-1">
											<label
												className="col-md-2 col-form-label pt-0"
											>
												Status Pegawai
											</label>
											<Col md="10">
												{this.state.data_summary ? (
													<>
														{this.state.data_summary.presensi_summary_employee_categories_name_full !== "" && this.state.data_summary.presensi_summary_employee_categories_name_full !== null
															? this.state.data_summary.presensi_summary_employee_categories_name_full
															: "-"}
													</>
												) : (
													<Shimmer>
														<div style={{ width: "100%", height: '15px' }}></div>
													</Shimmer>
												)}

											</Col>
										</Row>
										<Row className="mb-1">
											<label
												className="col-md-2 col-form-label pt-0"
											>
												Saldo Cuti
											</label>
											<Col md="10">
												{this.state.saldo ? (
													<>
														{this.state.saldo !== "" && this.state.saldo !== null
															? this.state.saldo + ' Hari'
															: "-"}
													</>
												) : (
													<Shimmer>
														<div style={{ width: "100%", height: '15px' }}></div>
													</Shimmer>
												)}

											</Col>
										</Row>
										{this.state.data_periode ? (
											<>
												{
													this.state.data_periode.period_financial_revision_status == 0
														? <>
															<Row className="mb-1">
																<label
																	className="col-md-2 col-form-label pt-0"
																>
																	Buat Revisi
																</label>
																<Col md="10">
																	{this.state.data_summary ? (
																		<>
																			<a className="btn btn-sm btn-success" href="#" onClick={() => {
																				this.setState({
																					GenerateType: 4
																				}, function () {
																					this.generateUlang();
																				});
																			}}>Jabatan/Grade</a>
																			{" "}
																			{
																				this.state.data_summary.presensi_summary_employee_categories_uuid == '5c2e9672-248b-461d-b75d-c479aa39276c' ||
																					this.state.data_summary.presensi_summary_employee_categories_uuid == 'a19447a1-1ace-47ac-adbe-6821c79c68b0' ||
																					this.state.data_summary.presensi_summary_employee_categories_uuid == '1d6805ff-6c56-4e08-ba4b-f666677cd237' ||
																					this.state.data_summary.presensi_summary_employee_categories_uuid == '9d05d51a-a28d-42e5-9938-21e8640f1a67' ?
																					<>
																						{" "}
																						<a className="btn btn-sm btn-success" href="#" onClick={() => {
																							this.setState({
																								GenerateType: 6
																							}, function () {
																								this.generateUlang();
																							});
																						}}>Golongan/Pangkat</a>
																						{" "}
																					</>
																					: ''
																			}
																			<a className="btn btn-sm btn-success" href="#" onClick={() => {
																				this.setState({
																					GenerateType: 8
																				}, function () {
																					this.generateUlang();
																				});
																			}}>PLT / PLH</a>
																			{" "}
																			<a className="btn btn-sm btn-success" href="#" onClick={() => {
																				this.setState({
																					is_koreksi_kehadiran: true
																				});
																			}}>
																				Koreksi Kehadiran
																			</a>{" "}
																			<a className="btn btn-sm btn-success" href="#" onClick={() => {
																				let employeeSelected = {
																					employee_uuid: this.queryParams.get('pegawai_uuid'),
																					employee_name: this.state.data_summary.presensi_summary_employee_name,
																					employee_full_name: this.state.data_summary.presensi_summary_employee_full_name,
																					employee_current_position_name: this.state.data_summary.presensi_summary_employee_current_position_name,
																					employee_nip: this.state.data_summary.presensi_summary_employee_nip,
																					employee_status_name: this.state.data_summary.presensi_summary_employee_categories_name_full
																				}
																				console.log(employeeSelected)
																				localStorage.setItem('employeeSelected', JSON.stringify(employeeSelected))
																				this.setState({
																					is_cuti: true
																				});
																			}}>Cuti</a>{" "}
																			<a className="btn btn-sm btn-success" href="#" onClick={() => {
																				this.setState({
																					GenerateType: 5
																				}, function () {
																					this.generateUlang();
																				});
																			}}>Generate Ulang</a>
																		</>
																	) : (
																		<Shimmer>
																			<div style={{ width: "100%", height: '15px' }}></div>
																		</Shimmer>
																	)}



																</Col>
															</Row>
														</>
														: ''
												}
											</>
										) : (
											<Shimmer>
												<div style={{ width: "100%", height: '15px' }}></div>
											</Shimmer>
										)}



										<hr />
										<Row className="mb-2 mt-3">
											<label
												className="col-md-2 col-form-label pt-0"
											>
											</label>
											<Col md="5">
												<label
													className="col-form-label"
												>
													Sebelum Revisi
												</label>

											</Col>
											<Col md="5">
												<label
													className="col-form-label"
												>
													Setelah Revisi
												</label>

											</Col>
										</Row>

										<Row className="mb-1">
											<label
												className="col-md-2 col-form-label pt-0"
											>
												Jabatan
											</label>
											<Col md="5">
												{this.state.data_summary ? (
													<>
														{this.state.data_summary.presensi_summary_employee_current_position_name !== "" && this.state.data_summary.presensi_summary_employee_current_position_name !== null
															? this.state.data_summary.presensi_summary_employee_current_position_name
															: "-"}
													</>
												) : (
													<Shimmer>
														<div style={{ width: "100%", height: '15px' }}></div>
													</Shimmer>
												)}

											</Col>
											<Col md="5">

												{this.state.data_summary ? (
													<>
														{this.state.data_summary.presensi_summary_revisi_employee_current_position_name !== "" && this.state.data_summary.presensi_summary_revisi_employee_current_position_name !== null
															? this.state.data_summary.presensi_summary_revisi_employee_current_position_name
															: "-"}
													</>
												) : (
													<Shimmer>
														<div style={{ width: "100%", height: '15px' }}></div>
													</Shimmer>
												)}

											</Col>
										</Row>
										<Row className="mb-1">
											<label
												className="col-md-2 col-form-label pt-0"
											>
												Grade
											</label>
											<Col md="5">
												{
													this.state.data_summary ? (
														<>
															{this.state.data_summary.presensi_summary_emp_grade !== "" && this.state.data_summary.presensi_summary_emp_grade !== null
																? this.state.data_summary.presensi_summary_emp_grade
																: "-"}
														</>
													) : (
														<Shimmer>
															<div style={{ width: "100%", height: '15px' }}></div>
														</Shimmer>
													)
												}

											</Col>
											<Col md="5">
												{
													this.state.data_summary ? (
														<>
															{this.state.data_summary.presensi_summary_revisi_employee_current_grade !== "" && this.state.data_summary.presensi_summary_revisi_employee_current_grade !== null
																? this.state.data_summary.presensi_summary_revisi_employee_current_grade
																: "-"}
														</>
													) : (
														<Shimmer>
															<div style={{ width: "100%", height: '15px' }}></div>
														</Shimmer>
													)
												}

											</Col>
										</Row>
										<Row className="mb-1">
											<label
												className="col-md-2 col-form-label pt-0"
											>
												Golongan/Pangkat
											</label>
											<Col md="5">
												{this.state.data_summary ? (
													<>
														{this.state.data_summary.presensi_summary_employee_current_rank_name !== "" && this.state.data_summary.presensi_summary_employee_current_rank_name !== null
															? this.state.data_summary.presensi_summary_employee_current_rank_group_room + ' - ' + this.state.data_summary.presensi_summary_employee_current_rank_name
															: "-"}
													</>
												) : (
													<Shimmer>
														<div style={{ width: "100%", height: '15px' }}></div>
													</Shimmer>
												)}

											</Col>
											<Col md="5">
												{
													this.state.data_summary ? (
														<>
															{this.state.data_summary.presensi_summary_revisi_employee_current_rank_name !== "" && this.state.data_summary.presensi_summary_revisi_employee_current_rank_name !== null
																? this.state.data_summary.presensi_summary_revisi_employee_current_rank_group_room + ' - ' + this.state.data_summary.presensi_summary_revisi_employee_current_rank_name
																: "-"}
														</>
													) : (
														<Shimmer>
															<div style={{ width: "100%", height: '15px' }}></div>
														</Shimmer>
													)
												}
											</Col>
										</Row>

										<Row className="mb-1" >
											<label
												className="col-md-2 col-form-label pt-0"
											>
												PLT / PLH
											</label>
											<Col md="5">
												{this.state.data_summary ? (
													<>
														{this.state.data_summary.presensi_summary_tunkin_plt_plh !== "" && this.state.data_summary.presensi_summary_tunkin_plt_plh !== null
															? this.state.data_summary.presensi_summary_tunkin_plt_plh
															: "-"}
													</>
												) : (
													<Shimmer>
														<div style={{ width: "100%", height: '15px' }}></div>
													</Shimmer>
												)}

											</Col>
											<Col md="5">
												{this.state.data_summary ? (
													<>
														{this.state.data_summary.presensi_summary_revisi_tunkin_plt_plh !== "" && this.state.data_summary.presensi_summary_revisi_tunkin_plt_plh !== null
															? this.state.data_summary.presensi_summary_revisi_tunkin_plt_plh
															: "-"}
													</>
												) : (
													<Shimmer>
														<div style={{ width: "100%", height: '15px' }}></div>
													</Shimmer>
												)}

											</Col>
										</Row>
										{this.state.data_summary && this.state.data_summary.presensi_summary_is_tunkin == 1 ? (
											<div>
												<hr />
												<Row>
													<Col md={2}></Col>
													<Col md={4}
														style={{ textAlign: 'right' }}
														>
														DATA TUNJANGAN KINERJA
													</Col>
													<Col md={4}>
														<AvCheckboxGroup name="rev_tunkin" errorMessage="Agreement harus di centang">
															<AvCheckbox label=" " value="1" 
																disabled={this.state.data_periode.period_financial_revision_status>0}
																style={{ transform: 'scale(1.2)' }}
																checked={this.state.rev_tunkin > 0}
																onClick={() => {
																	if(this.state.rev_tunkin>0){
																		this.setState({ rev_tunkin: 0 })
																	}else{
																		this.setState({ rev_tunkin: 1 })
																	}
																}}
															/>
														</AvCheckboxGroup>
													</Col>
												</Row>
												{/* <label
													className="col-md-6 col-form-label pt-0 "
													style={{ textAlign: 'right' }}
												>
													DATA TUNJANGAN KINERJA
												</label>
															*/}
												
												<Row className="mb-2 mt-3">
													<label
														className="col-md-2 col-form-label pt-0"
													>

													</label>
													<Col md="5">
														<label
															className="col-form-label"
														>
															Sebelum Revisi
														</label>

													</Col>
													<Col md="5">
														<label
															className="col-form-label"
														>
															Setelah Revisi
														</label>

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														% Tidak Masuk
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_presentase_tunkin_tidak_masuk !== "" && this.state.data_summary.presensi_summary_presentase_tunkin_tidak_masuk !== null
																	? this.state.data_summary.presensi_summary_presentase_tunkin_tidak_masuk
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_presentase_tunkin_tidak_masuk !== "" && this.state.data_summary.presensi_summary_revisi_presentase_tunkin_tidak_masuk !== null
																	? this.state.data_summary.presensi_summary_revisi_presentase_tunkin_tidak_masuk
																	: "- "}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														% Terlambat
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_presentase_tunkin_telat_masuk !== "" && this.state.data_summary.presensi_summary_presentase_tunkin_telat_masuk !== null
																	? this.state.data_summary.presensi_summary_presentase_tunkin_telat_masuk
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_presentase_tunkin_telat_masuk !== "" && this.state.data_summary.presensi_summary_revisi_presentase_tunkin_telat_masuk !== null
																	? this.state.data_summary.presensi_summary_revisi_presentase_tunkin_telat_masuk
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														% Pulang Awal
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_presentase_tunkin_pulang_cepat !== "" && this.state.data_summary.presensi_summary_presentase_tunkin_pulang_cepat !== null
																	? this.state.data_summary.presensi_summary_presentase_tunkin_pulang_cepat
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_presentase_tunkin_pulang_cepat !== "" && this.state.data_summary.presensi_summary_revisi_presentase_tunkin_pulang_cepat !== null
																	? this.state.data_summary.presensi_summary_revisi_presentase_tunkin_pulang_cepat
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														% Single Finger
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_presentase_tunkin_single_finger !== "" && this.state.data_summary.presensi_summary_presentase_tunkin_single_finger !== null
																	? this.state.data_summary.presensi_summary_presentase_tunkin_single_finger
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_presentase_tunkin_single_finger !== "" && this.state.data_summary.presensi_summary_revisi_presentase_tunkin_single_finger !== null
																	? this.state.data_summary.presensi_summary_revisi_presentase_tunkin_single_finger
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														Hukuman Disiplin
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_presentase_punishment_discipline !== "" && this.state.data_summary.presensi_summary_presentase_punishment_discipline !== null
																	? this.state.data_summary.presensi_summary_presentase_punishment_discipline
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_presentase_punishment_discipline !== "" && this.state.data_summary.presensi_summary_revisi_presentase_punishment_discipline !== null
																	? this.state.data_summary.presensi_summary_revisi_presentase_punishment_discipline
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														Total Potongan
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_tunkin_total !== "" && this.state.data_summary.presensi_summary_tunkin_total !== null
																	? this.state.data_summary.presensi_summary_tunkin_total
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_tunkin_total !== "" && this.state.data_summary.presensi_summary_revisi_tunkin_total !== null
																	? this.state.data_summary.presensi_summary_revisi_tunkin_total
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														Status
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_status_penugasan !== "" && this.state.data_summary.presensi_summary_status_penugasan !== null
																	? this.state.data_summary.presensi_summary_status_penugasan
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_status_penugasan !== "" && this.state.data_summary.presensi_summary_revisi_status_penugasan !== null
																	? this.state.data_summary.presensi_summary_revisi_status_penugasan
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												{/* <Row className="mb-1">
													<Col md="5">
														<AvCheckboxGroup name="rev_tunkin" errorMessage="Agreement harus di centang">
															<AvCheckbox label="Revisi Data Tunjangan Kinerja" value="1"
																checked={this.state.rev_tunkin > 0}
																onClick={() => {
																	if(this.state.rev_tunkin>0){
																		this.setState({ rev_tunkin: 0 })
																	}else{
																		this.setState({ rev_tunkin: 1 })
																	}
																}}
															/>
														</AvCheckboxGroup>
													</Col>
												</Row> */}
											</div>
										) : (
											""
										)}

										{this.state.data_summary && this.state.data_summary.presensi_summary_is_honorarium == 1 ? (
											<div>
												<hr />
												{/* <label
													className="col-md-12 col-form-label pt-0 text-center"
												>
													DATA HONORARIUM
												</label> */}
												<Row>
													<Col md={2}></Col>
													<Col md={4}
														style={{ textAlign: 'right' }}
														>
														DATA HONORARIUM
													</Col>
													<Col md={4}>
														<AvCheckboxGroup name="rev_honorarium" errorMessage="Agreement harus di centang">
															<AvCheckbox label=" " value="1" 
																disabled={this.state.data_periode.period_financial_revision_status>0}
																style={{ transform: 'scale(1.2)' }}
																checked={this.state.rev_honorarium > 0}
																onClick={() => {
																	if(this.state.rev_honorarium>0){
																		this.setState({ rev_honorarium: 0 })
																	}else{
																		this.setState({ rev_honorarium: 1 })
																	}
																}}
															/>
														</AvCheckboxGroup>
													</Col>
												</Row>
												<Row className="mb-2 mt-3">
													<label
														className="col-md-2 col-form-label pt-0"
													>

													</label>
													<Col md="5">
														<label
															className="col-form-label"
														>
															Sebelum Revisi
														</label>

													</Col>
													<Col md="5">
														<label
															className="col-form-label"
														>
															Setelah Revisi
														</label>

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														Status Penugasan
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_status_penugasan !== "" && this.state.data_summary.presensi_summary_status_penugasan !== null
																	? this.state.data_summary.presensi_summary_status_penugasan
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_status_penugasan !== "" && this.state.data_summary.presensi_summary_revisi_status_penugasan !== null
																	? this.state.data_summary.presensi_summary_revisi_status_penugasan
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														% Tidak Masuk
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_presentase_ptsp_tidak_masuk !== "" && this.state.data_summary.presensi_summary_presentase_ptsp_tidak_masuk !== null
																	? this.state.data_summary.presensi_summary_presentase_ptsp_tidak_masuk
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_presentase_ptsp_tidak_masuk !== "" && this.state.data_summary.presensi_summary_revisi_presentase_ptsp_tidak_masuk !== null
																	? this.state.data_summary.presensi_summary_revisi_presentase_ptsp_tidak_masuk
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														% Terlambat
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_presentase_ptsp_telat_masuk !== "" && this.state.data_summary.presensi_summary_presentase_ptsp_telat_masuk !== null
																	? this.state.data_summary.presensi_summary_presentase_ptsp_telat_masuk
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_presentase_ptsp_telat_masuk !== "" && this.state.data_summary.presensi_summary_revisi_presentase_ptsp_telat_masuk !== null
																	? this.state.data_summary.presensi_summary_revisi_presentase_ptsp_telat_masuk
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														% Pulang Awal
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_presentase_ptsp_pulang_cepat !== "" && this.state.data_summary.presensi_summary_presentase_ptsp_pulang_cepat !== null
																	? this.state.data_summary.presensi_summary_presentase_ptsp_pulang_cepat
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_presentase_ptsp_pulang_cepat !== "" && this.state.data_summary.presensi_summary_revisi_presentase_ptsp_pulang_cepat !== null
																	? this.state.data_summary.presensi_summary_revisi_presentase_ptsp_pulang_cepat
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														% Single Finger
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_presentase_ptsp_single_finger !== "" && this.state.data_summary.presensi_summary_presentase_ptsp_single_finger !== null
																	? this.state.data_summary.presensi_summary_presentase_ptsp_single_finger
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_presentase_ptsp_single_finger !== "" && this.state.data_summary.presensi_summary_revisi_presentase_ptsp_single_finger !== null
																	? this.state.data_summary.presensi_summary_revisi_presentase_ptsp_single_finger
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														Total Potongan
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_ptsp_total !== "" && this.state.data_summary.presensi_summary_ptsp_total !== null
																	? this.state.data_summary.presensi_summary_ptsp_total
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_ptsp_total !== "" && this.state.data_summary.presensi_summary_revisi_ptsp_total !== null
																	? this.state.data_summary.presensi_summary_revisi_ptsp_total
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												{/* <Row className="mb-1">
													<Col md="5">
														<AvCheckboxGroup name="rev_honorarium" errorMessage="Agreement harus di centang">
															<AvCheckbox label="Revisi Data Honorarium" value="1" 
																checked={this.state.rev_honorarium > 0}
																onClick={() => {
																	if(this.state.rev_honorarium>0){
																		this.setState({ rev_honorarium: 0 })
																	}else{
																		this.setState({ rev_honorarium: 1 })
																	}
																}}
															/>
														</AvCheckboxGroup>
													</Col>
												</Row> */}
											</div>
										) : (
											""
										)}
										{this.state.data_summary && this.state.data_summary.presensi_summary_is_uang_makan == 1 ? (
											<div>
												<hr />
												{/* <label
													className="col-md-12 col-form-label pt-0 text-center"
												>
													DATA UANG MAKAN
												</label> */}
												<Row>
													<Col md={2}></Col>
													<Col md={4}
														style={{ textAlign: 'right' }}
														>
														DATA UANG MAKAN
													</Col>
													<Col md={4}>
														<AvCheckboxGroup name="rev_uangmakan" errorMessage="Agreement harus di centang">
															<AvCheckbox label=" " value="1"
																style={{ transform: 'scale(1.2)' }} 
																disabled={this.state.data_periode.period_financial_revision_status>0}
																checked={this.state.rev_uangmakan > 0}
																onClick={() => {
																	if(this.state.rev_uangmakan>0){
																		this.setState({ rev_uangmakan: 0 })
																	}else{
																		this.setState({ rev_uangmakan: 1 })
																	}
																}}
															/>
														</AvCheckboxGroup>
													</Col>
												</Row>
												<Row className="mb-2 mt-3">
													<label
														className="col-md-2 col-form-label pt-0"
													>

													</label>
													<Col md="5">
														<label
															className="col-form-label"
														>
															Sebelum Revisi
														</label>

													</Col>
													<Col md="5">
														<label
															className="col-form-label"
														>
															Setelah Revisi
														</label>

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														Status
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_status_penugasan !== "" && this.state.data_summary.presensi_summary_status_penugasan !== null
																	? this.state.data_summary.presensi_summary_status_penugasan
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_status_penugasan !== "" && this.state.data_summary.presensi_summary_revisi_status_penugasan !== null
																	? this.state.data_summary.presensi_summary_revisi_status_penugasan
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														Jumlah Hadir
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_total_hadir !== "" && this.state.data_summary.presensi_summary_total_hadir !== null
																	? this.state.data_summary.presensi_summary_total_hadir
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_total_hadir !== "" && this.state.data_summary.presensi_summary_revisi_total_hadir !== null
																	? this.state.data_summary.presensi_summary_revisi_total_hadir
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														Alpha
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_total_alpha !== "" && this.state.data_summary.presensi_summary_total_alpha !== null
																	? this.state.data_summary.presensi_summary_total_alpha
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_total_alpha !== "" && this.state.data_summary.presensi_summary_revisi_total_alpha !== null
																	? this.state.data_summary.presensi_summary_revisi_total_alpha
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														Cuti
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_total_cuti !== "" && this.state.data_summary.presensi_summary_total_cuti !== null
																	? this.state.data_summary.presensi_summary_total_cuti
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_total_cuti !== "" && this.state.data_summary.presensi_summary_revisi_total_cuti !== null
																	? this.state.data_summary.presensi_summary_revisi_total_cuti
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														Dinas
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_total_dinas !== "" && this.state.data_summary.presensi_summary_total_dinas !== null
																	? this.state.data_summary.presensi_summary_total_dinas
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_total_dinas !== "" && this.state.data_summary.presensi_summary_revisi_total_dinas !== null
																	? this.state.data_summary.presensi_summary_revisi_total_dinas
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												<Row className="mb-1">
													<label
														className="col-md-2 col-form-label pt-0"
													>
														Tugas Belajar/CLTN/Ditugaskan Diinstansi Lain/IIPC
													</label>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_total_tugas_belajar !== "" && this.state.data_summary.presensi_summary_total_tugas_belajar !== null
																	? this.state.data_summary.presensi_summary_total_tugas_belajar
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
													<Col md="5">
														{this.state.data_summary ? (
															<>
																{this.state.data_summary.presensi_summary_revisi_total_tugas_belajar !== "" && this.state.data_summary.presensi_summary_revisi_total_tugas_belajar !== null
																	? this.state.data_summary.presensi_summary_revisi_total_tugas_belajar
																	: "-"}
															</>
														) : (
															<Shimmer>
																<div style={{ width: "100%", height: '15px' }}></div>
															</Shimmer>
														)}

													</Col>
												</Row>
												{/* <Row className="mb-1">
													<Col md="5">
														<AvCheckboxGroup name="rev_uangmakan" errorMessage="Agreement harus di centang">
															<AvCheckbox label="Revisi Data Uang Makan" value="1" 
																checked={this.state.rev_uangmakan > 0}
																onClick={() => {
																	if(this.state.rev_uangmakan>0){
																		this.setState({ rev_uangmakan: 0 })
																	}else{
																		this.setState({ rev_uangmakan: 1 })
																	}
																}}
															/>
														</AvCheckboxGroup>
													</Col>
												</Row> */}
											</div>
										) : (
											""
										)}
										<hr />
										<Row className="mb-1">
											<label
												className="col-md-12 col-form-label pt-0 mb-3 text-center"
											>
												Daftar Presensi
											</label>
											<Col md="12">
												{this.state.data_summary ? (
													<>
														<div className="table-responsive" style={{ minWidth: '100%' }}>
															<Table
																className="table table-striped table-bordered table-hover"
															>
																<Thead>
																	<Tr>
																		<Th className="text-center" width="*">Tanggal</Th>
																		<Th className="text-left" width="*">Hari</Th>
																		<Th className="text-center" width="*">Masuk</Th>
																		<Th className="text-center" width="*">Pulang</Th>

																		<Th className="text-center" width="*">Hadir</Th>
																		<Th className="text-center" width="*">T</Th>
																		<Th className="text-center" width="*">H</Th>

																		<Th className="text-center" width="*">S.Finger</Th>
																		<Th className="text-center" width="*">T</Th>
																		<Th className="text-center" width="*">H</Th>

																		<Th className="text-center" width="*">Terlambat</Th>
																		<Th className="text-center" width="*">T</Th>
																		<Th className="text-center" width="*">H</Th>

																		<Th className="text-center" width="*">Pulang Cepat</Th>
																		<Th className="text-center" width="*">T</Th>
																		<Th className="text-center" width="*">H</Th>
																		<Th className="text-center" width="*">Keterangan</Th>
																		<Th className="text-center" width="100px">Pola Kerja</Th>
																		<Th className="text-center" width="*">Aksi</Th>
																	</Tr>
																</Thead>
																<Tbody>
																	{
																		Object.entries(this.state.rows).map((item, key) => {
																			const thisId = item[0];
																			let cancelAvailable = false
																			if (item[1].result_checkin !== null && item[1].result_checkout !== null) {
																				cancelAvailable = true
																			}
																			let color = "";
																			if (item[1].presensi_result_type == 1 || item[1].presensi_result_type == 10) color = "text-danger";
																			if (item[1].presensi_result_type > 1 && item[1].presensi_result_type != 10) color = "text-primary";

																			return (
																				<tr key={key}>
																					<td className={`text-center ${color}`}>{this.dateParse(item[1].presensi_result_date)}</td>
																					<td className={`text-left ${color}`}>{item[1].presensi_result_day_name}</td>

																					{
																						item[1].presensi_result_type != null && item[1].presensi_result_is_present == 0 ?
																							<>
																								<td className="text-center">{item[1].presensi_result_checkin} {this.getIconPresensi(item[1].presensi_result_checkin, item[1].presensi_result_checkin_from)}</td>
																								<td className="text-center">{item[1].presensi_result_checkout} {this.getIconPresensi(item[1].presensi_result_checkout, item[1].presensi_result_checkout_from)}</td>
																								<td className="text-center">{item[1].presensi_result_is_present === 0 ? '-' : 'Ya'}</td>
																								<td className="text-center">{item[1].presensi_result_precent_tunkin_not_present}</td>
																								<td className="text-center">{item[1].presensi_result_precent_ptsp_not_present}</td>
																								<td className={`text-center ${color}`} colSpan="11">{item[1].presensi_result_type_name}</td>
																								<td className="text-center">
																									{
																										item[1].presensi_result_type !== null && item[1].presensi_result_type != 10 && item[1].presensi_result_type != 3 && item[1].presensi_result_type != 5 ?
																											<>
																											
																												{
																													this.state.data_periode ?
																														this.state.data_periode.period_financial_revision_status == 0 ?
																															<>
																																<span>
																																	<Button
																																		className="btn btn-danger btn-sm"
																																		id={"delete-" + thisId}
																																		onClick={() => {
																																			this.setState({
																																				cancelDate: item[1].presensi_result_date,
																																				result_type: item[1].presensi_result_type,
																																				confirm: true
																																			})
																																		}}
																																		style={{
																																			padding: '2px 5px'
																																		}}
																																		disabled={!cancelAvailable}>
																																		<i className="uil-times-circle"></i>
																																	</Button>
																																	<Tooltip
																																		style={{
																																			marginBottom: 2
																																		}}
																																		placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
																																		toggle={() => {
																																			this.setState({
																																				["delete" + thisId]: !this.state["delete" + thisId]
																																			})
																																		}}
																																	>Batalkan</Tooltip>
																																</span>
																															</>
																															:
																															''
																														:
																														''
																												}

																											</>
																											: ''
																									}
																								</td>
																							</>
																							:
																							<>
																								<td className="text-center">{item[1].presensi_result_checkin} {this.getIconPresensi(item[1].presensi_result_checkin, item[1].presensi_result_checkin_from)}</td>
																								<td className="text-center">{item[1].presensi_result_checkout} {this.getIconPresensi(item[1].presensi_result_checkout, item[1].presensi_result_checkout_from)}</td>
																								<td className="text-center">{item[1].presensi_result_is_present === 0 ? '-' : 'Ya'}</td>
																								{
																									item[1].presensi_result_type != 3 ?
																										<>
																											<td className="text-center">{item[1].presensi_result_precent_tunkin_not_present}</td>
																											<td className="text-center">{item[1].presensi_result_precent_ptsp_not_present}</td>


																											<td className="text-center">{item[1].presensi_result_is_single_finger === 0 ? '-' : '03:45:00'}</td>
																											<td className="text-center">{item[1].presensi_result_precent_tunkin_single_finger}</td>
																											<td className="text-center">{item[1].presensi_result_precent_ptsp_single_finger}</td>

																											<td className="text-center">{item[1].presensi_result_late === null || item[1].presensi_result_late == '00:00:00' ? '-' : item[1].presensi_result_late}</td>
																											<td className="text-center">{item[1].presensi_result_precent_tunkin_late}</td>
																											<td className="text-center">{item[1].presensi_result_precent_ptsp_late}</td>

																											<td className="text-center">{item[1].presensi_result_early === null || item[1].presensi_result_early == '00:00:00' ? '-' : item[1].presensi_result_early}</td>
																											<td className="text-center">{item[1].presensi_result_precent_tunkin_early}</td>
																											<td className="text-center">{item[1].presensi_result_precent_ptsp_early}</td>

																											<td className="text-left">{item[1].presensi_type == -1 ? item[1].presensi_type_name : item[1].presensi_result_type_name}</td>
																											<td className="text-left">{item[1].presensi_result_working_pattern}</td>
																										</> :
																										<>
																											<td className="text-center">{item[1].presensi_result_precent_tunkin_not_present}</td>
																											<td className="text-center">{item[1].presensi_result_precent_ptsp_not_present}</td>
																											<td className={`text-center ${color}`} colSpan="11">{item[1].presensi_result_type_name}</td>
																										</>
																								}


																								<td className="text-center">
																									{
																										item[1].presensi_result_type !== null && item[1].presensi_result_type != 10 && item[1].presensi_result_type != 3 && item[1].presensi_result_type != 5 ? <>
																											{
																												this.state.data_periode ?
																													this.state.data_periode.period_financial_revision_status == 0 ?
																														<>
																															<span>
																																<Button
																																	className="btn btn-danger btn-sm"
																																	id={"delete-" + thisId}
																																	onClick={() => {
																																		this.setState({
																																			cancelDate: item[1].presensi_result_date,
																																			result_type: item[1].presensi_result_type,
																																			confirm: true
																																		})
																																	}}
																																	style={{
																																		padding: '2px 5px'
																																	}}
																																	disabled={!cancelAvailable}>
																																	<i className="uil-times-circle"></i>
																																</Button>
																																<Tooltip
																																	style={{
																																		marginBottom: 2
																																	}}
																																	placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
																																	toggle={() => {
																																		this.setState({
																																			["delete" + thisId]: !this.state["delete" + thisId]
																																		})
																																	}}
																																>Batalkan</Tooltip>
																															</span>
																														</>
																														:
																														''
																													:
																													''
																											}

																										</>
																											: ''
																									}
																								</td>

																							</>
																					}

																				</tr>
																			)
																		})
																	}
																</Tbody>
															</Table>
														</div>
													</>
												) : (
													<Shimmer>
														<div style={{ width: "100%", height: '15px' }}></div>
													</Shimmer>
												)}



											</Col>
										</Row>

										<Row className="mb-1">
											<Col md="2"></Col>
											<Col md="10">
												<Link to={`?pegawai&uuid=` + this.props.uuid}>
													<Button color="danger">
														<i className="uil-arrow-left"></i> Kembali
													</Button>
												</Link>{" "}
												{
													((this.state.rev_tunkin>0||this.state.rev_honorarium>0||this.state.rev_uangmakan>0) && this.state.data_periode.period_financial_revision_status<1)?
													<Button color="success" type="submit" 
														onClick={() => {
															this.setState({
																rev_edit: true,
															});
														}}
													>
														<i className="uil-arrow-up-right"></i> Simpan
													</Button>
													:''
												}
											</Col>
										</Row>
									</AvForm>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
				<Modal
					size={this.state.modalSize}
					isOpen={this.state.showUpload}
				/* toggle={() => {
					this.setState({
						showUpload: !this.state.showUpload,
					})
					setTimeout(() => {
						this.setState({
							modalSize: 'sm'
						})
					}, 500);
				}} */
				>
					<div className="modal-header">
						<h5
							className="modal-title mt-0"
							id="myLargeModalLabel"
						>
							Import Data CPNS
						</h5>
						<button
							onClick={() => {
								this.setState({
									showUpload: false,
								})
								setTimeout(() => {
									this.setState({
										modalSize: 'sm'
									})
								}, 500);
							}}
							type="button"
							className="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div className="modal-body">
					</div>
				</Modal>
				<ConfirmAlert
					confirmTitle="Konfirmasi!"
					confirmInfo={this.state.confirmInfo ? this.state.confirmInfo : "Apakah anda yakin?"}
					loadingTitle="Mengambil data..."
					loadingInfo="Tunggu beberapa saat"
					successTitle="Berhasil!"
					successInfo="Data berhasil disimpan"
					failedTitle="Gagal!"
					failedInfo="Data gagal disimpan"
					showConfirm={this.state.confirm}
					showLoading={this.state.loading}
					showSuccess={this.state.success}
					showFailed={this.state.failed}
					response={this.confirmResponse}
				/>
				{this.state.redirect ? (
					<Redirect
						to={
							`/kepegawaian/revisi_keuangan.html?pegawai&uuid=` +
							this.props.uuid
						}
					/>
				) : null}
				{this.state.is_grade ? (
					<Redirect
						to={
							`/kepegawaian/revisi_keuangan.html?update_grade&uuid=` +
							this.props.uuid
						}
					/>
				) : null}
				{this.state.is_koreksi_kehadiran ? (
					<Redirect
						to={
							`/izinpegawai/koreksikehadiran.html?create&is_revisi=1&pegawai_uuid=` +
							this.queryParams.get('pegawai_uuid') + `&period_revision_uuid=` +
							this.queryParams.get('uuid')
						}
					/>
				) : null}
				{this.state.is_dinas ? (
					<Redirect
						to={
							`/izinpegawai/dinas.html?create&is_revisi=1&pegawai_uuid=` +
							this.queryParams.get('pegawai_uuid') + `&period_revision_uuid=` +
							this.queryParams.get('uuid')
						}
					/>
				) : null}
				{this.state.is_cuti ? (
					// set current employee uuid selected

					<Redirect
						to={
							`/izinpegawai/cuti.html?create&is_revisi=1&pegawai_uuid=` +
							this.queryParams.get('pegawai_uuid') + `&period_revision_uuid=` +
							this.queryParams.get('uuid')
						}
					/>
				) : null}
			</Fragment>
		);
	}
}

export default IndexView;
